function u(r) {
  var e = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return e[t] === void 0 && (e[t] = r(t)), e[t];
  };
}
export {
  u as default
};
//# sourceMappingURL=index.es344.js.map
